<template>
<div>
        <top-navbar></top-navbar>


        <div class="container-fluid mb-5">
          Calender
        </div>


        <content-footer></content-footer>
</div>
</template>
<script>
 import axios from 'axios';
 import authService from '@/auth.service';
  import TopNavbar from './../../layout/TopNavbar.vue'
  import ContentFooter from './../../layout/ContentFooter.vue'


  export default {
    data() {
      return {
        access_token:authService.isLoggedIn(),
        userid:authService.isUserid(),
       
      }

    },

    components :{
        ContentFooter,
        TopNavbar
    },

}

</script>
